import DbService from '../db.service';
import schema from './background-task.schema';

const service = new DbService('background_task', { schema });


const getBackgroundTasks = async ({
  types = ['AI_PROCESS'],
  statuses = ['PENDING', 'CANCELLED', 'COMPLETED', 'FAILED', 'REVIEWED'],
  userAuthId,
}) => {
  // const request = service
  //   .select()
  //   .in('type', types)
  //   .in('status', status);
  
  // if (userAuthId) {
  //   request.in('user_id', [userAuthId]);
  // }

  // const response = await request;

  const response = await service.selectByKey({
    selectKey: 'getBackgroundTasks',
    params: { types, statuses, userAuthId },
  });

  const { data } = service.processResponse(response);

  return data;
};

const deleteBackgroundTask = async (id) => {
  await service.remove(id);
};

const updateBackgroundTask = async (id, data) => {
  await service.updateOne(id, data);
};

const BackgroundTaskService = Object.assign(service, {
  getBackgroundTasks,
  deleteBackgroundTask,
  updateBackgroundTask,
});

export default BackgroundTaskService;
